import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
  boardData: [],
  taskData: [],
  loading: false,
  tsLoading: false,
  error: null,
});

const actions = {
  async ToAddBoard({ commit }, data) {
    console.log("AddBoard");
    try {
      commit('toAddBoardBegin');
      commit('toAddBoardSuccess', data);

    } catch (err) {
      commit('toAddBoardErr', err);
    }
  },

  async ToAddTask({ commit }, data) {
    console.log("AddTask", data);
    try {
      commit('toAddTaskBegin');
      commit('toAddTaskSuccess', data);
    } catch (err) {
      commit('toAddTaskErr', err);
    }
  },

  async ToDeleteTask({ commit }, data) {
    try {
      commit('toDeleteTaskBegin');
      commit('toDeleteTaskSuccess', data);
    } catch (err) {
      commit('toDeleteTaskErr', err);
    }
  },

  async labelReadAll({commit}, filtros) {
      commit('labelReadAllBegin');
      // ?tagIds=3,7 acota el tablero a los contactos que tienen TODAS esas
      // etiquetas. Sin el parametro se comporta igual que siempre.
      const ids = (filtros && Array.isArray(filtros.tagIds) && filtros.tagIds.length)
        ? `?tagIds=${filtros.tagIds.join(',')}`
        : '';
      await DataService.get(`/opportunity${ids}`).then((response) => {
        commit('labelReadAllSuccess', response.data.data);
      }).catch((err) => {
        commit('labelReadAllErr', err);
      });
  },

  async labelContactUpdate({commit}, data) {
    commit('labelContactUpdateBegin');
    await DataService.patch(`/opportunity/${data.id}`, data).then((response) => {
        commit('labelContactUpdateSuccess', response.data.data);

        notification.success({
            message: response.data.message,
            placement: 'topRight'
        });
    }).catch((err) => {
      commit('labelContactUpdateErr', err);
    });
  },

};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
};
